






















































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Button, Toast } from 'vant';
import EXIF from 'exif-js';
import { FileType } from '@/common/ts/enum';
import { getOssSignature } from '@/api/api';
import axios from 'axios';
Vue.use(Button).use(Toast);

const reader = new FileReader();
const img = new Image();
const imgCdnPrefix = 'https://image2.cqcb.com/';
@Component
export default class Uploader extends Vue {
  @Prop({ default: FileType.Image }) fileType!: FileType;
  @Prop({ default: 9 }) maxImage!: number;
  @Prop({ default: 15 }) videoMaxDuration!: number;
  // data
  displayImages: string[] = [];
  uploadImages: any[] = [];
  videoFile: any = '';
  loading = false;
  FileType = FileType;
  showUploaderBtn = true;
  hasUploaded = false;
  formData: any = [];

  @Watch('uploadImages')
  onUploadImagesChange(newval: any[], oldval: any[]) {
    if (newval.length >= this.maxImage) {
      this.showUploaderBtn = false;
    } else {
      this.showUploaderBtn = true;
    }
    if (newval.length > oldval.length) {
      this.hasUploaded = false;
    }
  }

  // 获取图片base64Url
  getImageFileLocalUrl(e: any) {
    const payloadFiles = e.target.files;
    const files: any[] = [];
    Object.keys(payloadFiles).forEach((key) => {
      files.push(payloadFiles[key]);
    });

    if (this.displayImages.length + files.length > this.maxImage) {
      return Toast('图片只能上传' + this.maxImage + '张');
    }
    let fileIndex = 0;
    if (!files.length) {
      return;
    }
    reader.readAsDataURL(files[fileIndex]);
    reader.onloadend = () => {
      this.handelImageRotate(files[fileIndex], reader.result);
      fileIndex++;
      if (fileIndex < files.length) {
        reader.readAsDataURL(files[fileIndex]);
      } else {
        // this.selectedImages = [...this.selectedImages, ...files];
        // this.displayImages = [...this.displayImages, ...displayImages];
      }
    };
    console.log(
      'check file input value: ',
      (this.$refs.inputImage as HTMLInputElement).value,
    );
  }
  // 处理图片旋的情况
  handelImageRotate(file: any, imgUrl: any) {
    const img = new Image();
    EXIF.getData(file, () => {
      const Orientation = EXIF.getTag(file, 'Orientation');
      img.src = imgUrl;
      img.onload = () => {
        // 缩放图片需要的canvas
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const originWidth = img.width;
        const originHeight = img.height;
        // 最大尺寸限制
        const maxWidth = 1280;
        const maxHeight = 720;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        // 图片尺寸超过预设尺寸的限制时
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        if (!context) {
          return;
        }
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 具体处理各种画面旋转的情况
        if (Orientation && Orientation !== 1) {
          switch (Orientation) {
            case 6: // 旋转90度
              canvas.width = targetHeight;
              canvas.height = targetWidth;
              context.rotate(Math.PI / 2);
              // (0,-imgHeight) 从旋转原理图那里获得的起始点
              context.drawImage(
                img,
                0,
                -targetHeight,
                targetWidth,
                targetHeight,
              ); // 关键语句
              break;
            case 3: // 旋转180度
              context.rotate(Math.PI);
              context.drawImage(
                img,
                -targetWidth,
                -targetHeight,
                targetWidth,
                targetHeight,
              );
              break;
            case 8: // 旋转-90度
              canvas.width = targetHeight;
              canvas.height = targetWidth;
              context.rotate((3 * Math.PI) / 2);
              context.drawImage(
                img,
                -targetWidth,
                0,
                targetWidth,
                targetHeight,
              );
              break;
          }
        } else {
          context.drawImage(img, 0, 0, targetWidth, targetHeight);
        }
        // canvas转 base64
        this.displayImages.push(canvas.toDataURL('image/*'));
        // 控制上传图片数量
        if (this.displayImages.length >= this.maxImage) {
          this.showUploaderBtn = false;
        }
        // canvas转 blob用于 oss 上传
        canvas.toBlob((blob) => {
          const fileName = file.name;
          const blobFile: any = {};
          blobFile.name = fileName;
          blobFile.file = blob;
          this.uploadImages = [...this.uploadImages, blobFile];
        });
      };
    });
  }
  // 获取视频文件信息
  getVideoFileInfo(e: any) {
    window.URL = window.URL || window.webkitURL;
    if (!e.target.files.length) {
      return;
    }
    const videoReader = new FileReader();
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const videoFile = e.target.files[0];
    const videoTag: any = document.createElement('video');
    videoReader.readAsDataURL(videoFile);
    try {
      videoReader.onloadend = () => {
        const localVideo: any = document.querySelector('#local-video');
        if (localVideo) {
          localVideo.src = URL.createObjectURL(videoFile);
        } else {
          videoTag.src = URL.createObjectURL(videoFile);

          videoTag.id = 'local-video';
          (this.$refs.container as Vue & {
            appendChild: (e: any) => void;
          }).appendChild(videoTag);
        }

        (document.querySelector(
          '#local-video',
        ) as HTMLVideoElement).onloadedmetadata = () => {
          const duration = (document.getElementById(
            'local-video',
          ) as HTMLVideoElement).duration;
          if (Math.round(duration) > this.videoMaxDuration) {
            (document.querySelector('#inputVideo') as HTMLInputElement).value =
              '';
            (this.$refs.container as HTMLElement).removeChild(
              document.querySelector('video') as HTMLElement,
            );
            return Toast.fail(
              '视频长度超过' + this.videoMaxDuration + 's，请本地处理后再上传',
            );
          }
          this.videoFile = videoFile;
          this.displayImages.push(require('@/assets/video-file.png'));
          // this.genVideoCover();
        };
      };
    } catch (err) {
      console.log(err);
      Toast('an error occurred', err);
    }
    return;
  }
  // 绘制视频封面
  genVideoCover() {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const domVideo: any = document.querySelector('#local-video');
    const scale = 0.5;
    canvas.width = domVideo.videoWidth * scale;
    canvas.height = domVideo.videoHeight * scale;
    if (!context) {
      return;
    }
    setTimeout(() => {
      context.drawImage(domVideo, 0, 0, canvas.width, canvas.height);
      this.displayImages.push(canvas.toDataURL('image/png'));
    }, 1000);
  }
  // 移除所选图片
  removeImage(index: number) {
    console.log('clear file input');
    (this.$refs.inputImage as HTMLInputElement).value = '';
    console.log(
      '=====>file value after: ',
      (this.$refs.inputImage as HTMLInputElement).value,
    );
    this.hasUploaded = false;
    this.displayImages.splice(index, 1);
    this.uploadImages.splice(index, 1);
    if ((this.$refs.container as HTMLElement).querySelector('#local-video')) {
      (document.querySelector('#inputVideo') as any).value = '';
      (this.$refs.container as Vue & {
        removeChild: (e: any) => void;
      }).removeChild(document.querySelector('video'));
    }
    if (this.fileType === FileType.Video) {
      this.videoFile = '';
    }
    this.showUploaderBtn = true;
    this.uploadComplete(this.uploadImages);
  }
  onUploadToOss() {
    if (window.udid || localStorage.getItem('unionid')) {
      this.uploadToOss();
    } else {
      // this.uploadToOss();
      Toast('请在上游客户端或微信参与');
    }
    // this.uploadToOss();
  }

  async uploadOssWithSignature(fileData: any) {
    const res = await getOssSignature();
    if (!res) {
      console.log('illegal hostname, this service is only fo cqcb.com');
      return;
    }
    const formData = new FormData();
    formData.append('key', `${(res as any).dir}${+new Date()}${fileData.name}`);
    formData.append('policy', (res as any).policy);
    formData.append('OSSAccessKeyId', (res as any).accessid);
    formData.append('success_action_status', '200');
    formData.append('callback', (res as any).callback);
    formData.append('signature', (res as any).signature);

    formData.append('name', fileData.name); // 文件名
    formData.append(
      'file',
      this.fileType === FileType.Image ? fileData.file : fileData,
    ); // 文件，选择时存在data上(图片和视频的文件对象区别对待)
    this.formData = formData; // 将formData对象存入data中，方便后续使用

    const ret = await axios.request({
      url: (res as any).host,
      data: formData,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    // return imgCdnPrefix + decodeURIComponent(ret.data.body);
    return ret;
  }

  // 上传阿里云
  uploadToOss() {
    if (this.fileType === FileType.Image) {
      if (!this.uploadImages.length) {
        return Toast('未选择图片');
      }
      this.loading = true;
      Promise.all(
        this.uploadImages.map((item, index) => {
          return new Promise((resolve, reject) => {
            this.uploadOssWithSignature(item).then((res: any) => {
              if (res.status === 200) {
                resolve(imgCdnPrefix + decodeURIComponent(res.data.body));
              } else {
                reject(res);
              }
            });
          });
        }),
      )
        .then((result) => {
          Toast.success('上传成功');
          this.hasUploaded = true;
          this.loading = false;
          this.uploadComplete(result);
        })
        .catch((err) => {
          console.log(err);
          Toast.fail(`图片上传失败:${err.statusText}`);
          this.loading = false;
        });
    } else {
      if (!this.videoFile) {
        return Toast.fail('未选择视频');
      }
      this.loading = true;
      this.uploadOssWithSignature(this.videoFile)
        .then((result: any) => {
          if (result.status === 200) {
            Toast.success('上传成功');
            this.hasUploaded = true;
            this.loading = false;
            this.uploadComplete(
              imgCdnPrefix + decodeURIComponent(result.data.body),
            );
          } else {
            Toast.fail(`视频上传失败:${result.statusText}`);
            this.loading = false;
          }
        })
        .catch((err: any) => {
          Toast.fail(`视频上传失败:${err.statusText}`);
          this.loading = false;
        });
    }
  }
  @Emit()
  uploadComplete(result: any) {
    return result;
  }
}
